import { useTranslation } from 'react-i18next'
import { InputLabel, MenuItem, Select, Stack, TextField } from '@mui/material'
import { SelectChangeEvent } from '@mui/material/Select'
import { AppointmentType } from '../../../../constants'
import { appointmentTypeToDisplayText } from '../../../../util/appointmentTypeToDisplayText'
import { StyledFormContainer, StyledFormControl } from './styles'

interface AppointmentTypeConfig {
  duration_in_minutes: number
}
interface AppointmentFormProps {
  appointmentData: {
    appointmentType?: string
    date: string
    time: string
  }
  availableAppointmentTypes: Array<{
    type: AppointmentType
    config: AppointmentTypeConfig
  }>
  onAppointmentTypeChange: (event: SelectChangeEvent) => void
  onDateChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onTimeChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  minDate?: string
  minTime?: string
}
export const AppointmentForm = ({
  appointmentData,
  availableAppointmentTypes,
  onAppointmentTypeChange,
  onDateChange,
  onTimeChange,
  minDate,
  minTime,
}: AppointmentFormProps) => {
  const { t } = useTranslation()

  return (
    <StyledFormContainer spacing={3} data-testid="appointment-create-form">
      <StyledFormControl fullWidth>
        <InputLabel>{t('common.label.appointmentType')}</InputLabel>
        <Select
          value={appointmentData.appointmentType || ''}
          onChange={onAppointmentTypeChange}
          label={t('common.label.appointmentType')}
          data-testid="appointment-create-type-select"
        >
          {availableAppointmentTypes.map(({ type }) => (
            <MenuItem key={type} value={type} data-testid={`appointment-create-type-option-${type}`}>
              {appointmentTypeToDisplayText[type]}
            </MenuItem>
          ))}
        </Select>
      </StyledFormControl>

      <Stack direction="row" spacing={2}>
        <TextField
          type="date"
          label={t('common.label.date')}
          value={appointmentData.date}
          onChange={onDateChange}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            min: minDate,
          }}
          fullWidth
          data-testid="appointment-create-date-input"
        />
        <TextField
          type="time"
          label={t('common.label.time')}
          value={appointmentData.time}
          onChange={onTimeChange}
          InputLabelProps={{
            shrink: true,
          }}
          inputProps={{
            min: minTime,
          }}
          fullWidth
          data-testid="appointment-create-time-input"
        />
      </Stack>
    </StyledFormContainer>
  )
}
